import PropTypes from 'prop-types';
import {Alert, AlertTitle, Container} from '@mui/material';
import useAuth from '../hooks/useAuth';
import {isPlatformOwner} from '../utils/ownerAnalytics';

export default function PlatformOwnerGuard({children}) {
  const {user} = useAuth();
  if (!isPlatformOwner(user)) return (
    <Container sx={{py: 4}}>
      <Alert severity="error"><AlertTitle>Acesso restrito</AlertTitle>Este painel está disponível apenas para os proprietários da 1Lead.</Alert>
    </Container>
  );
  return children;
}
PlatformOwnerGuard.propTypes = {children: PropTypes.node};
